import {Button} from 'antd'
import {useMapContext} from '@/components/MindMap/index.mjs'

export const PropertiesPaneButtonExportReq = (props) => {
    const map = useMapContext()
    const {exportReqAll} = map.commands

    const onClick = () => {
        const fmIds = [...map.topNodes(map.selectedNodes)]
            .map(e => e.data.pkid)
            .filter(a => a)

        exportReqAll({expBizFlag: '0', fmIds})
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            导出软件需求1-1汇总
        </Button>
    )
}

export const PropertiesPaneButtonExportReq2 = (props) => {
    const map = useMapContext()
    const {exportReqAll2} = map.commands

    const onClick = () => {
        const fmIds = [...map.topNodes(map.selectedNodes)]
            .map(e => e.data.pkid)
            .filter(a => a)

        exportReqAll2({fmIds})
    }

    return (
        <Button
            onClick={onClick}
            {...props}
        >
            导出软件需求1-2汇总
        </Button>
    )
}
